import marked from 'marked'

const MONTHS = [
  'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August',
  'September', 'October', 'November', 'December'
]

// Render markdown in place
function markdown (input) {
  if (input === null) {
    return false
  } else {
    return marked(String(input), { smartypants: true, sanitize: true })
  }
}

export { MONTHS, markdown }



// WEBPACK FOOTER //
// ./src/utils.js